import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { IconButton, Typography } from "@mui/material";
import { BreadCrumbIcon } from "app/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { useStyles } from "./styles";

type Props = {
  subTitle?: string;
  onBackClick?(): void;
  title: string;
  iconPosition?: "start" | "end";
  className?: string;
};

const BreadCrumb = ({
  subTitle,
  onBackClick,
  title,
  iconPosition = "start",
  className,
}: Props) => {
  const styles = useStyles();
  const { i18n } = useTranslation();
  const isDetailView = Boolean(onBackClick && subTitle);

  const renderBackButton = () => (
    <IconButton onClick={onBackClick} className={styles.backButton}>
      {i18n.dir() === "ltr" ? (
        <ArrowForward className={styles.backIcon} />
      ) : (
        <ArrowBack className={styles.backIcon} />
      )}
    </IconButton>
  );

  const renderIcon = () => {
    if (onBackClick && !isDetailView) {
      return renderBackButton();
    }

    return <BreadCrumbIcon />;
  };

  if (isDetailView) {
    return (
      <div
        className={`${styles.mainHeader} ${styles.mainHeaderEndIcon} ${
          className || ""
        }`}
        dir={i18n.dir()}
      >
        <Typography className={styles.activeText}>{subTitle}</Typography>
        <Typography className={styles.separator}>/</Typography>
        <Typography className={styles.parentText}>{title}</Typography>
        <BreadCrumbIcon />
        {renderBackButton()}
      </div>
    );
  }

  return (
    <div
      className={`${styles.mainHeader} ${
        iconPosition === "end" ? styles.mainHeaderEndIcon : ""
      } ${className || ""}`}
      dir={i18n.dir()}
    >
      {iconPosition === "start" ? renderIcon() : null}
      <Typography className={styles.textHeader}>{title}</Typography>
      {subTitle ? (
        <Typography className={styles.textHeader}>
          &nbsp;/&nbsp;{subTitle}
        </Typography>
      ) : null}
      {iconPosition === "end" ? renderIcon() : null}
    </div>
  );
};

export default BreadCrumb;
